import { render, staticRenderFns } from "./RequestHandling.vue?vue&type=template&id=8e2ebbaa&"
import script from "./RequestHandling.vue?vue&type=script&lang=ts&"
export * from "./RequestHandling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports